import { api } from 'utility';
import {
  getCreditUrl,
  getShebaServiceUrl,
  getCardServiceUrl,
  getRequestSettelmentFromGuildUrl,
  getFinancialSettelmentWallet,
  getShebaInformationUrl,
  getConfigTransfer,
} from 'URLs';

const source = api.cancelToken;
let cancelToken;
export function inquiryPaymentAccountNumber(params) {
  return api.get(getShebaInformationUrl(params)).then((res) => res.data);
}

export function getSheba(params) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }
  cancelToken = source.source();
  return api
    .get(getShebaServiceUrl(), { params, cancelToken: cancelToken.token })
    .then((res) => res.data);
}

export function getCard(params) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }

  cancelToken = source.source();

  return api.get(getCardServiceUrl(), { params, cancelToken: cancelToken.token }).then((res) => {
    return res.data.result.filter((item) => {
      return item?.number;
    });
  });
}

export function credit() {
  return api.get(getCreditUrl()).then((res) => res.data);
}

export function configTransfer() {
  return api.get(getConfigTransfer()).then((res) => res.data);
}

export function withdrawalGuild(param) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }
  cancelToken = source.source();
  return api
    .post(
      getRequestSettelmentFromGuildUrl(),
      {
        ...param,
      },
      { cancelToken: cancelToken.token },
    )
    .then((res) => res.data);
}

export function withdrawalWallet(param) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }
  cancelToken = source.source();
  return api
    .post(
      getFinancialSettelmentWallet(),
      {
        ...param,
      },
      { cancelToken: cancelToken.token },
    )
    .then((res) => res.data);
}

export function postCard(data) {
  return api.post(getCardServiceUrl(), data).then((res) => res.data);
}

export function postSheba(data) {
  return api.post(getShebaServiceUrl(), data).then((res) => res.data);
}
export default {
  getSheba,
  getCard,
  credit,
  withdrawalGuild,
  withdrawalWallet,
  postCard,
  getShebaServiceUrl,
  inquiryPaymentAccountNumber,
  configTransfer,
};
